import React from 'react';
import { Fade } from 'react-awesome-reveal';

import {
  Button,
  WysiwygField,
} from '../../../../components';

import './style.scss';

const CTAFullWidth = ({ entity }) => {
  return (
    <div className="Paragraph CTAFullWidth">
      <Fade triggerOnce bottom distance="50px" duration={500}>
        <div className="CTAFullWidth__content">
          <div className="CTAFullWidth__content__wrapper">
            <h2>{entity.getIn(['field_title', 0, 'value'])}</h2>
            <WysiwygField
              property="schema:text"
              html={entity.getIn(['field_body', 0, 'processed'])}
            />
          </div>
          { entity.getIn(['field_link', 0, 'uri']) && (
            <Button
              href={entity.getIn(['field_link', 0, 'uri'])}
              className="CTAFullWidth__button"
              withIcon
              buttonIcon
              primary
            >
              {entity.getIn(['field_link', 0, 'title'])}
            </Button>
          )}
        </div>
      </Fade>
    </div>
  );
};

export default CTAFullWidth;

